import React, { useContext, useEffect, useState } from "react";
import classNames from "classnames";

import { LayoutContext, SCREENTYPE } from "../../../hooks/useLayout";

import SanitizeHTML from "../../sanitizeHTML";

import styles from "./blocText.module.scss";
import Image from "next/legacy/image";

interface IBlocText {
    className?: string;
    contenu: {
        title: string;
        subtitle: string | null;
        text: string[];
        imageUrl: string | null;
    };
    isCentered?: boolean;
    isDark?: boolean;
    isImage?: boolean;
    viewport?: string;
}

const BlocText = ({
    className = "",
    contenu,
    isCentered,
    isDark = false,
    isImage = true,
    viewport,
}: IBlocText) => {
    const { title, subtitle, text, imageUrl } = contenu;
    const { screenType } = useContext(LayoutContext);
    const [isMobile, setIsMobile] = useState(true);

    useEffect(() => {
        setIsMobile(viewport == SCREENTYPE.MOBILE || screenType == SCREENTYPE.MOBILE);
    }, [screenType]);

    return (
        <section
            data-component="BlocText"
            className={classNames(styles.me, {
                [className]: className,
                [styles.isDark]: isDark,
            })}
        >
            <div
                className={classNames(styles.container, "body", {
                    [styles.centered]: isCentered,
                })}
            >
                <div className={styles.content}>
                    <h2 className={styles.title}>{title}</h2>
                    <h3 className={styles.subtitle}>{subtitle}</h3>
                    <div className={styles.text}>
                        {text &&
                            text.map((paragraph, index) => (
                                <SanitizeHTML key={index} html={paragraph} tag="p" />
                            ))}
                    </div>
                </div>
                {isImage && imageUrl && (
                    <div className={styles.images}>
                        {isMobile ? (
                            <Image src={imageUrl} alt="mobile" width={800} height={500} />
                        ) : (
                            <Image src={imageUrl} alt="desktop" width={600} height={600} />
                        )}
                    </div>
                )}
            </div>
        </section>
    );
};
export default BlocText;
